import React from 'react';
import { Outlet } from 'react-router';
import PreviewModeToggleNavigation from '../../components/PreviewModeToggleNavigation';

const UnderExternalAdministration: React.FC = () => {
  return (
    <>
      <PreviewModeToggleNavigation />
      <Outlet />
    </>
  );
};

export default UnderExternalAdministration;
